import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@fgb/core';
import { ErrorStateService } from '@fgb/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.scss'],
})
export class MaintenancePageComponent implements OnInit {
  showAppleLink = true;
  showGoogleLink = true;

  constructor(
    private router: Router,
    public errorService: ErrorStateService,
    private authService: AuthService,
    public deviceDetector: DeviceDetectorService
  ) {
    this.authService.checkApiStatus();

    firstValueFrom(this.authService.checkMaintenceMode()).then(
      (result) => {
        this.router.navigate(['/']);
      },
      (error) => {
        this.router.navigate(['maintenance']);
      }
    );
  }

  ngOnInit() {
    this.downloadAppLink();
  }

  downloadAppLink() {
    if (this.deviceDetector.os.match('iOS')) {
      this.showGoogleLink = false;
    } else if (this.deviceDetector.os.match('Android')) {
      this.showAppleLink = false;
    }
  }
}
